"use client";

import Link from "next/link";
import { useTheme } from "./theme/ThemeProvider";

const SOCIAL_LINKS = [
  { href: "https://twitter.com", label: "Twitter" },
  { href: "https://discord.com", label: "Discord" },
  { href: "mailto:hello@phytoncoin.org", label: "Email" },
];

export default function Footer() {
  const { theme } = useTheme();

  return (
    <footer className="footer" data-theme-context={theme}>
      <div className="footer__inner">
        <p>© {new Date().getFullYear()} PhytonCoin Foundation</p>
        <div className="footer__social">
          {SOCIAL_LINKS.map(({ href, label }) => (
            <Link key={href} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
              {label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
